module.exports = __webpack_public_path__ + "static/media/Snapshot Vid_1721828574204.7b177fa1. Script 06 2024";